import axios from "axios";

export const getFiduciaryData = ({ organizationUen }) => {
  const requestUrl = `/data/fiduciary`;

  let params = {
    organizationUen: organizationUen
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/fiduciary.js